import { Modal } from "@mui/material";
import React from "react";
import { FaGem } from "react-icons/fa";

export default function Loading({
  title = "Processing...",
  message = "Communicating with Tanushree Saha Studio API...",
}) {
  return (
    <Modal open>
      <div className="flex items-center justify-center min-h-screen p-4 bg-black/40 backdrop-blur-xs">
        <div className="bg-white rounded-3xl p-8 shadow-2xl border border-amber-200/80 w-full max-w-sm flex flex-col items-center text-center relative overflow-hidden">
          {/* Animated Spinner */}
          <div className="relative w-20 h-20 mb-4 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full border-4 border-amber-100 border-t-amber-600 animate-spin" />
            <div className="w-10 h-10 rounded-full bg-amber-50 text-amber-700 flex items-center justify-center text-lg shadow-2xs">
              <FaGem className="animate-pulse" />
            </div>
          </div>

          <h3 className="text-base font-bold text-slate-900 mb-1">{title}</h3>
          <p className="text-xs text-slate-500 font-medium leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    </Modal>
  );
}
